export default "__VITE_ASSET__CGQX1k2b__"